import { hasReadPermission } from "@/auth/utils";

const target_menus = {
  title: 'Targets',
  icon: 'TargetIcon',
  tagVariant: 'light-warning',
  children: []
};

if (hasReadPermission("custom-targets")) {
  target_menus.children.push({
    title: 'Custom Targets',
    icon: 'TargetIcon',
    route: {
      path: '/custom-targets'
    },
  });
}

if (hasReadPermission("custom-sets")) {
  target_menus.children.push({
    title: 'Customer Sets',
    icon: 'SettingsIcon',
    route: {
      path: '/customer-sets'
    },
  });
}

export default [target_menus];
